var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown",value:(_vm.dropdownDirValues),expression:"dropdownDirValues"}],class:[("" + _vm.cssPrefix)]},[_vm._t("default",[_vm._v(_vm._s(_vm.$t((_vm.i18nPathPrefix + ".menu"))))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }